export const PREVENT_NAVIGATION_MODAL_SYMBOL_NAME = 'sport_around_prevent_navigation_modal_global_symbol_name'